module.exports = __webpack_public_path__ + "static/media/info-profilephoto.eedb3f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-profilephoto.png
// module id = 1747
// module chunks = 0